/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ServiceType } from '../models';
/**
 * ServiceTypesApi - axios parameter creator
 * @export
 */
export const ServiceTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * returns the list of all the service type code and its respective value :param _:
         * @summary Get list of service type codes and its values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/serviceTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceTypesApi - functional programming interface
 * @export
 */
export const ServiceTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * returns the list of all the service type code and its respective value :param _:
         * @summary Get list of service type codes and its values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceTypesApi.getServiceTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceTypesApi - factory interface
 * @export
 */
export const ServiceTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceTypesApiFp(configuration)
    return {
        /**
         * returns the list of all the service type code and its respective value :param _:
         * @summary Get list of service type codes and its values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceType>> {
            return localVarFp.getServiceTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceTypesApi - interface
 * @export
 * @interface ServiceTypesApi
 */
export interface ServiceTypesApiInterface {
    /**
     * returns the list of all the service type code and its respective value :param _:
     * @summary Get list of service type codes and its values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceTypesApiInterface
     */
    getServiceTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceType>>;

}

/**
 * ServiceTypesApi - object-oriented interface
 * @export
 * @class ServiceTypesApi
 * @extends {BaseAPI}
 */
export class ServiceTypesApi extends BaseAPI implements ServiceTypesApiInterface {
    /**
     * returns the list of all the service type code and its respective value :param _:
     * @summary Get list of service type codes and its values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceTypesApi
     */
    public getServiceTypes(options?: RawAxiosRequestConfig) {
        return ServiceTypesApiFp(this.configuration).getServiceTypes(options).then((request) => request(this.axios, this.basePath));
    }
}

